const ComboType = Object.freeze({
  Normal: 1, // Combo bình thường
  Table: 2, // Combo table
  Tree: 3, // Combo tree
})

const FILTER_DEBOUNCE_TIME = 500 // ms

export {
  ComboType,
  FILTER_DEBOUNCE_TIME,
}
